package com.rainbowclubs.rainbow.presentation.splash

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import rainbowclubs.composeapp.generated.resources.Res
import rainbowclubs.composeapp.generated.resources.login_button
import rainbowclubs.composeapp.generated.resources.logo_image_cd
import rainbowclubs.composeapp.generated.resources.rainbow_clubs
import rainbowclubs.composeapp.generated.resources.signup_button

@Composable
fun LandingScreen(
    onNavigateTo: (LandingScreenNavigation) -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(16.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        Image(
            painter = painterResource(Res.drawable.rainbow_clubs),
            contentDescription = stringResource(Res.string.logo_image_cd),
        )

        Spacer(modifier = Modifier.height(32.dp))

        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            Button(
                onClick = { onNavigateTo(LandingScreenNavigation.Login) },
                modifier = Modifier.weight(1f)
            ) {
                Text(stringResource(Res.string.login_button))
            }
            Button(
                onClick = { onNavigateTo(LandingScreenNavigation.Signup) },
                modifier = Modifier.weight(1f)
            ) {
                Text(stringResource(Res.string.signup_button))
            }
        }
    }
}

sealed class LandingScreenNavigation {
    object Login : LandingScreenNavigation()
    object Signup : LandingScreenNavigation()
}

@Preview
@Composable
private fun LandingScreenPreview() {
    LandingScreen(
        onNavigateTo = {},
    )
}
